import * as React from "react";

const PhoneInput = (props) => {
  return <input type="tel" {...props} />;
};

export default PhoneInput;
